// Header.js
import React from 'react';

const Header = () => (
  <header className="text-center py-3">
    <h1>Templify</h1>
    <h4 className='text-muted'>Email Template Generator</h4>
  </header>
);

export default Header;
